import urlConstructor from 'utils/urlConstructor'

export const REGISTER_ROUTE = '/:locale?/signup'
export const LOGIN_ROUTE = '/:locale?/login'
export const SOCIAL_LOGIN_ROUTE = '/auth/:provider'
export const LOGOUT_ROUTE = '/logout'
export const USER_ROUTE = '/coach-profile'
export const WRONG_PERMISSION_ROUTE = '/wrong-permission'
export const NO_MATCH_ROUTE = '/no-match'
export const INITIAL_ROUTE = urlConstructor(':teamUuid', ':seasonId')
export const TEAMS_ROUTE = '/teams'
export const CLUB_SUBSCRIPTION_ROUTE = '/clubs/:clubUuid/subscription'

export const SEASONS_ROUTE = '/seasons'

export const TRAINING_DASHBOARD_ROUTE = '/trainings/:trainingUuid'

export const MATCH_DASHBOARD_ROUTE = '/matches/:matchId'
export const EVENT_DASHBOARD_ROUTE = '/general-events/:eventUuid'

export const TEAM_MENU_ROUTE = '/current-team/menu'
export const TEAM_DASHBOARD_ROUTE = '/current-team'
export const TEAM_PLAYER_CREATE_ROUTE = '/current-team/player/create'
export const TEAM_PLAYER_EDIT_ROUTE = '/current-team/player/:playerId/edit'
export const TEAM_PLAYER_DASHBOARD_ROUTE =
  '/current-team/player/:playerId/overview'
export const TEAM_PLAYER_TRANSFER_HISTORY_ROUTE =
  '/current-team/player/:playerId/transfer-history'

export const EVENT_ROUTE = '/events'
export const ACTIVITIES_ROUTE = '/activities/drills'
export const DRILL_CREATE_ROUTE = '/activities/drills/create'
export const DRILL_EDIT_ROUTE = '/activities/drills/:drillUuid/edit'
export const DRILLS_CATEGORIES = '/activities/drills-categories'
export const TRAINING_PACKAGES_ROUTE = '/activities/training-packages'
export const TRAINING_PACKAGE_CREATE_ROUTE =
  '/activities/training-packages/create'
export const TRAINING_PACKAGE_EDIT_ROUTE =
  '/activities/training-packages/:trainingPackageUuid/edit'

export const LINEUPS_DASHBOARD_ROUTE = '/lineups'
export const LINEUP_CREATE_ROUTE = '/lineups/create'
export const LINEUP_EDIT_ROUTE = '/lineups/:lineupUuid/edit'

export const ARTICLES_DASHBOARD_ROUTE = '/articles'
export const ARTICLE_CREATE_ROUTE = '/create-article'
export const ARTICLE_EDIT_ROUTE = '/articles/:articleId/edit'
export const ARTICLES_CATEGORIES = '/articles-categories'

export const FAVORITES_ROUTE = '/favorites'

export const VIDEO_ANALYSIS_ROUTE = '/videos'
export const VIDEO_ROUTE = '/videos/:videoId'

export const TASK_MANAGEMENT_ROUTE = '/task-management'
export const TASK_ROUTE = '/task-group/:taskGroupUuid'

export const USER_MANAGEMENT_ROUTE = '/user-management'
